import queryString from 'query-string';

function savePageState(pageCode, pageState, overrideParams) {
    localStorage.setItem(pageCode, JSON.stringify({...pageState, ...overrideParams}));
}

function getPageState (pageCode, currentState) {
    const storageState = localStorage.getItem(pageCode);

    if (!!storageState) {
        const state = JSON.parse(storageState);
        return state;
    }

    return null;
}

function clearPageState(pageCode) {
    localStorage.setItem(pageCode, '');
}

const handleUrl = (url) => {
    const currentUrl = url.replace(/&amp;/g, '&');

    return queryString.parse(currentUrl);
}

const pluralizeDays = (n) => {
    switch (n) {
        case 1: return '1 день';
        case 2:
        case 3:
        case 4: return `${n} дня`;
        default: return `${n} дней`;
    }
}

export {savePageState, getPageState, clearPageState, handleUrl, pluralizeDays}